<template>
  <div class="all_container">
    <!-- 头部区 -->
    <div class="header_bar">
      <!-- <img src="../assets/logo.png" alt="" draggable="false" /> -->
      <div
        v-for="(item, index) in rightBtn"
        :key="index"
        class="right_btn"
        :class="{ btnSelect: index === i }"
        @click="selectChange(index)"
      >
        {{ item }}
      </div>
    </div>
    <!-- 主体区 -->
    <router-view></router-view>
    <!-- 底部区 -->
    <div class="footer_bar">
      <div class="footer_item">
        <span @click="goAboutUs(1)">关于我们</span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
        <span @click="goAboutUs(2)">用户协议</span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
        <span @click="goAboutUs(3)">隐私政策</span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
        <span @click="goAboutUs(4)">联系方式</span>
      </div>
      <div class="footer_item">版权所有者：娄底市公共交通有限公司</div>
      <div class="footer_item">ICP备案：湘ICP备2023007623号-1</div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {},
  props: {},
  data() {
    return {
      rightBtn: ['关于我们', '产品介绍', '首页'],
      i: 2,
      displacement: 0,
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.name === 'homePage') {
          this.i = 2
        } else if (val.name === 'about-us') {
          this.i = 0
        } else {
          this.i = 1
        }
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    selectChange(index) {
      if (this.i === index) {
        return
      }
      if (index === 0) {
        this.$router.push({
          name: 'about-us',
          params: {
            isShow: 1,
          },
        })
      } else if (index === 1) {
        this.$router.push({
          name: 'customBus',
        })
      } else {
        this.$router.push({
          name: 'homePage',
        })
      }
      this.i = index
    },
    goAboutUs(i) {
      if (this.$route.name === 'about-us') {
        this.$bus.$emit('set-us-content', i)
        return
      }
      this.$router.push({
        name: 'about-us',
        params: {
          isShow: i,
        },
      })
    },
  },
  beforeDestroy() {},
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.all_container {
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .header_bar {
    width: 100%;
    height: 90px;
    padding: 20px;
    box-sizing: border-box;
    background-image: url('../assets/bj.png');
    background-size: cover;
    position: relative;
    z-index: 9999;

    img {
      height: 100%;
    }

    .right_btn {
      float: right;
      width: 90px;
      border-radius: 20px;
      height: 35px;
      margin-top: 7.5px;
      background-color: #fff;
      margin-left: 20px;
      line-height: 35px;
      text-align: center;
      color: #333333;
      font-size: 15px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .btnSelect {
      background-color: #02A7F0;
      color: #fff;
    }
  }

  .footer_bar {
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
    z-index: 9999;
    background-color: #F0F5F8;

    .footer_item {
      font-size: 12px;
      text-align: center;
      color: #333;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      span {
        cursor: pointer;

        &:hover {
          color: #02A7F0;
        }
      }
    }
  }
}

@media only screen {
  @media (max-width: 768px) {
    .all_container {
      width: 100%;
      height: 100%;

      .header_bar {
        img {
          height: 30%;
          position: absolute;
          top: 10px;
          left: 10px;
        }

        .right_btn {
          margin: 30px 15px 0 0;
          float: right;
        }
      }

      .footer_bar {
        position: static;
      }
    }
  }
}
</style>